module.exports = __webpack_public_path__ + "img/calendar.9bc5b089.svg";